/**
 * Validates that an array of template configs doesn't contain duplicates (returns a specific field error).
 * @param selectedTemplates Array of { fieldId, templateId }
 * @returns Map of fieldId to boolean indicating if it has a collision
 */
export const getTemplateCollisions = (
  selectedTemplates: { fieldId: string; templateId: string | null }[]
): Record<string, boolean> => {
  const templateCount: Record<string, number> = {};

  // Count occurrences of each templateId
  selectedTemplates.forEach(({ templateId }) => {
    if (templateId) {
      templateCount[templateId] = (templateCount[templateId] || 0) + 1;
    }
  });

  // Mark fields that have a duplicate templateId
  const collisions: Record<string, boolean> = {};
  selectedTemplates.forEach(({ fieldId, templateId }) => {
    if (templateId && templateCount[templateId] > 1) {
      collisions[fieldId] = true;
    } else {
      collisions[fieldId] = false;
    }
  });

  return collisions;
};

/**
 * Gets all globally used template IDs except the one used by currentFieldId.
 */
export const getUnavailableTemplateIds = (
  currentFieldId: string,
  selectedTemplates: { fieldId: string; templateId: string | null }[]
): string[] => {
  const unavailable: string[] = [];
  selectedTemplates.forEach(({ fieldId, templateId }) => {
    if (fieldId !== currentFieldId && templateId) {
      unavailable.push(templateId);
    }
  });
  return unavailable;
};
